<template>
	<module class="g-crumb" flex="flex-center-cross" style="background: none;">
		<div v-for="(item, i) in crumb" :key="i" class="item">
			<ins v-if="i > 0">→</ins>
			<router-link v-if="i != crumb.length - 1 && item.path && item.path != '/transact'" :to="item.path">{{item.name}}</router-link>
			<span v-else>{{item.name}}</span>
		</div>
	</module>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		props: {
			current: String
		},
		
		computed: {
			...mapState(['elder']),
			
			crumb() {
				return [{
					path: '/',
					name: '首页'
				}].concat(Array.from(this.$route.matched.filter((item, index) => {
					return item.meta && item.meta.name && (!this.current || index != this.$route.matched.length - 1);
				}), item => {
					return {
						path: item.path,
						name: item.meta.name
					}
				})).concat(this.current ? [{
					name: this.current,
					path: ''
				}] : []);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-crumb {
		height: 44px;
		font-size: 13px;
		
		elder({
			font-size: 16px
		})
		
		.item:nth-last-child(1) a,
		.item:nth-last-child(1) span {
			color: #000;
		}
		
		a {
			color: #999;
			
			&:hover {
				color: #000;
			}
		}
		
		span {
			color: #999;
		}
		
		ins {
			margin: 0 .5em;
			color: #999;
		}
	}
</style>
